import React from "react";
import { Section, SectionTitle, Reveal } from "../components/Section";
import { MapPin, Calendar, Clock } from "lucide-react";
import { WEDDING_CONFIG } from "../config";

const EventCard = ({ title, date, time, venue, address, mapUrl, delay }) => (
  <Reveal delay={delay} className="bg-white/80 backdrop-blur-sm p-8 md:p-10 border border-gold/20 shadow-sm text-center">
    <p className="text-xs tracking-[0.3em] uppercase text-gold mb-3">Acara</p>
    <h3 className="font-serif text-3xl text-charcoal mb-6">{title}</h3>
    <div className="space-y-3 text-charcoal/80 mb-6">
      <div className="flex items-center justify-center gap-2 text-sm">
        <Calendar size={16} className="text-gold" />
        <span>{date}</span>
      </div>
      <div className="flex items-center justify-center gap-2 text-sm">
        <Clock size={16} className="text-gold" />
        <span>{time}</span>
      </div>
      <div className="flex items-start justify-center gap-2 text-sm max-w-xs mx-auto">
        <MapPin size={16} className="text-gold mt-0.5 flex-shrink-0" />
        <div>
          <p className="font-medium">{venue}</p>
          <p className="text-charcoal/60 mt-1 text-xs leading-relaxed">{address}</p>
        </div>
      </div>
    </div>
    <a
      href={mapUrl}
      target="_blank"
      rel="noreferrer"
      data-testid={`map-button-${title.toLowerCase().replace(/\s/g, '-')}`}
      className="btn-gold inline-block"
    >
      Lihat Lokasi
    </a>
  </Reveal>
);

export default function EventDetails({ weddingDate }) {
  const dateStr = weddingDate.toLocaleDateString("id-ID", {
    weekday: "long", day: "numeric", month: "long", year: "numeric",
  });

  return (
    <Section testId="event-details-section" className="bg-ivory">
      <SectionTitle overline="Save the Date" title="Acara" italic="Pernikahan" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        {WEDDING_CONFIG.events.map((ev, i) => (
          <EventCard
            key={ev.title}
            delay={i * 0.2}
            title={ev.title}
            date={dateStr}
            time={ev.time}
            venue={ev.venue}
            address={ev.address}
            mapUrl={WEDDING_CONFIG.mapsLink}
          />
        ))}
      </div>

      <Reveal delay={0.4} className="mt-10">
        <div className="aspect-[16/9] overflow-hidden border border-gold/20">
          <iframe
            title="Lokasi Acara"
            src={`https://maps.google.com/maps?q=${WEDDING_CONFIG.mapsQuery}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
            width="100%"
            height="100%"
            style={{ border: 0, filter: "saturate(0.85) sepia(0.08)" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </Reveal>
    </Section>
  );
}
